export { useShouldShowHero } from './use-should-show-hero';
